import { motion } from 'framer-motion';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_3939debc from '../styles/Step.module.less.js';

const Step = (props) => {
    const { isActive, isPassed } = props;
    const cx = useStyles(modules_3939debc);
    const stepClassNames = cx('step', {
        active: isActive,
        passed: isPassed,
    });
    // borderRadius задан через style для того, чтобы framer-motion его не анимировал при переходе на другой шаг
    return React.createElement(motion.div, { "data-qa": "Step", className: stepClassNames, style: { borderRadius: 8 }, layout: true });
};

export { Step };
//# sourceMappingURL=Step.js.map
